import React from 'react';
import { useState, useEffect } from 'react'; 
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Redux 

import { setIsEditedDoctorPreferences, setIsRefreshDoctorPreferences, setLanguage, setLockScreen, setNotifications, setSecurityPin, setTheme } from '../../redux/features/doctor/Account/preferences';

// Routes 

import { getDoctorPreferences, getGroup, updateDoctorPreferences } from '../../routes/doctor/patients';

// Components 

import Preferences from './preferences/Preferences';
import Account from './account/Account';
import Notifications from './notifications/Notifications';
import { setGroup } from '../../redux/features/doctor/Account/account';

const Container: React.FC = () => {

  const dispatch = useAppDispatch(); 

  const navigate = useNavigate(); 

  const colors = useAppSelector(state => state.theme.colors);

  const section = useAppSelector(state => state.navigation.section);
  const doctorPreferences = useAppSelector(state => state.doctorPreferences);
  const isRefreshDoctorPreferences = useAppSelector(state => state.doctorPreferences.isRefreshDoctorPreferences);
  const isEditedDoctorPreferences = useAppSelector(state => state.doctorPreferences.isEditedDoctorPreferences);
  const isMobile = useMediaQuery('(max-width:600px)');
  const sidebarWidth = `max(${isMobile ? 70 : 125}px, 5vw)`;

  const handleDoctorPreferences = async () => { 

    const res = await getDoctorPreferences() as any; 

    if (res.data.status === 200) { 

      dispatch(setLanguage(res?.data.doctorPreferences.language)); 
      dispatch(setTheme(res.data.doctorPreferences.theme)); 
      dispatch(setNotifications(res.data.doctorPreferences.notifications)); 
      dispatch(setSecurityPin(res.data.doctorPreferences.securityPin)); 
      dispatch(setLockScreen(res.data.doctorPreferences.lockScreen)); 

    }; 

  }; 

  // -- 

  const getUpdatedDoctorPreferences = async () => { 

    const res = await updateDoctorPreferences(doctorPreferences) as any; 

    if (res.data.status === 200) { 

      dispatch(setLanguage(res?.data.doctorPreferences.language)); 
      dispatch(setTheme(res.data.doctorPreferences.theme)); 
      dispatch(setNotifications(res.data.doctorPreferences.notifications)); 
      
    }; 

  }; 

  // -- 

  const handleAccountInfo = async () => { 

    const res = await getGroup(); 

    if (res?.data.status === 200) { 

      dispatch(setGroup(res.data.group)); 

    }; 

  }; 

  // -- 

  useEffect(() => { 

    handleDoctorPreferences(); 

    handleAccountInfo(); 

  },[]); 

  // -- 

  useEffect(() => { 

    if (isRefreshDoctorPreferences) { 

      handleDoctorPreferences(); 

      dispatch(setIsRefreshDoctorPreferences(false));

    }; 

  },[isRefreshDoctorPreferences]); 

  // -- 

  useEffect(() => { 

    if (isEditedDoctorPreferences) { 

      getUpdatedDoctorPreferences(); 

      dispatch(setIsEditedDoctorPreferences(false)); 

    };

  },[isEditedDoctorPreferences]);

  // -- 

  return (

    <Box component="main" sx={{ 
        position: 'absolute',
        top: '5vh', // Below NavBar
        left: sidebarWidth, // Right of Sidebar
        height: 'calc(100vh - 5vh)',
        width: `calc(100vw - ${sidebarWidth})`,
        backgroundColor: colors?.interface, 
        color: colors?.highlightedText,
        overflow: 'hidden', // Let children handle scrolling
        boxSizing: 'border-box',
      }}>

        { section === 'preferences' && <Preferences />}

        { section === 'notifications' && <Notifications />}

        { section === 'account' && <Account />}

    </Box>

  );

};

export default Container;